import { Header, SnackbarClose, SvgIcon } from 'components'
import { escDown, escUp } from './services'
import { ColumnWrapper, ContentContainer, ContentWrapper, TourAnchor, TourInsert } from './styled'

import CloseIcon from 'assets/close-icon.svg?react'
import AccountCenter from 'components/account-center'
import { FooterComponent } from 'components/footer'
import WelcomeModal from 'context/tour-guide/components/welcome-modal'
import { useTourGuide } from 'context/tour-guide/use-tour-guide'
import { useKey } from 'hooks'
import { useClickOutsideComponents } from 'hooks/use-click-outside-component'
import { useLocation } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { PendingTransactionsProvider } from 'services/pending-transactions-context'
import { useStore } from 'services/store'
import { colors } from 'theme'
import { AppWrapper } from '../../styling/common'
import { LayoutContent } from '../../styling/common/index'

// if theme null
if (!localStorage.getItem('theme')) {
  localStorage.setItem('theme', 'white')
}

export function AppLayout({ children }: { children: JSX.Element | JSX.Element[] }): JSX.Element {
  const { connectionModal, isDarkMode, setConnectionModal, setNavOpen } = useStore()
  const theme = colors(isDarkMode)
  const location = useLocation()
  const { run, currentStep } = useTourGuide()
  const runningOrPaused = run || currentStep > 0

  const { getReference } = useClickOutsideComponents(() => {
    setConnectionModal(false)
    if (!runningOrPaused) {
      setNavOpen(false)
    }
  })

  const buttonReference = getReference()
  const accountCenterReference = getReference()

  const blurOut = () => {
    if (buttonReference.current) {
      buttonReference.current.blur()
    }
  }

  useKey(
    'Escape',
    (event: KeyboardEvent) =>
      escDown(event, () => {
        if (connectionModal) setConnectionModal(false)
      }),
    (event: KeyboardEvent) => escUp(event, () => blurOut()),
  )

  return (
    <AppWrapper>
      <WelcomeModal />
      <TourAnchor>
        <TourInsert id="tour-anchor"></TourInsert>
      </TourAnchor>
      <PendingTransactionsProvider>
        <Header clickControlReference={buttonReference} />
        <LayoutContent>
          <ColumnWrapper>
            <ContentWrapper id={'app-layout'}>
              <ContentContainer
                showFooterCTA={location.pathname === '/' || location.pathname.includes('/about')}
                id="tour-checkpoint"
              >
                {children}
              </ContentContainer>
              <FooterComponent />
            </ContentWrapper>
          </ColumnWrapper>
        </LayoutContent>
        <AccountCenter show={connectionModal} clickControlReference={accountCenterReference} />
        <ToastContainer
          autoClose={5000}
          hideProgressBar
          closeButton={
            <SnackbarClose onClick={() => toast.dismiss()}>
              <SvgIcon icon={CloseIcon} />
            </SnackbarClose>
          }
          toastStyle={{
            background: theme.bg,
            alignItems: 'center',
            color: theme.primaryFontColor,
            boxShadow: theme.boxShadow,
            borderRadius: '10px',
          }}
        />
      </PendingTransactionsProvider>
    </AppWrapper>
  )
}
